export default "__VITE_ASSET__DAhgIQfP__"